module.exports = __webpack_public_path__ + "img/Files_And_Folder_Flatline.7583279b.svg";